import { render } from "./GiftHeader.vue?vue&type=template&id=7539ef3d"
import script from "./GiftHeader.vue?vue&type=script&lang=js"
export * from "./GiftHeader.vue?vue&type=script&lang=js"

import "./GiftHeader.vue?vue&type=style&index=0&id=7539ef3d&lang=scss"
script.render = render

export default script